import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { authApiClient } from '../../../api/axios';

export const fetchApiCredentials = async () => {
  const { data } = await authApiClient.get('/organizations/api-integrations/credentials');
  return data;
};

export const useGetApiCredentialsHandler = () => {
  const dispatch = useDispatch();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['api-credentials'],
    queryFn: fetchApiCredentials,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  });

  useEffect(() => {
    if (!isError) return;

    if (axios.isAxiosError(error)) {
      dispatch(
        showSnackbar({
          message: error.response?.data?.message || error.message,
          severity: 'error',
        }),
      );
    } else {
      dispatch(
        showSnackbar({
          message: 'Failed to fetch API credentials',
          severity: 'error',
        }),
      );
    }
  }, [dispatch, error, isError]);

  return {
    credentials: data,
    isLoading,
  };
};
